var render = function render(){
  var _vm$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._t("status", null, null, {
    loading: _vm.loading
  }), _vm._l(_vm.items, function (order, index) {
    var _order$createdAt, _order$createdAt$toDa, _vm$orders$index;
    return _c('page-section', {
      key: order._id,
      staticClass: "page-section--sm pb-0"
    }, [_c('template', {
      slot: "containerImmersive"
    }, [_c('tit-wrap-line', {
      attrs: {
        "noDivider": ""
      }
    }, [_c('template', {
      slot: "titleContents"
    }, [_c('div', {
      staticClass: "d-flex flex-column flex-sm-row align-sm-center"
    }, [_c('span', {
      staticClass: "tit tit--xxs"
    }, [_vm._v(_vm._s(order === null || order === void 0 ? void 0 : (_order$createdAt = order.createdAt) === null || _order$createdAt === void 0 ? void 0 : (_order$createdAt$toDa = _order$createdAt.toDate) === null || _order$createdAt$toDa === void 0 ? void 0 : _order$createdAt$toDa.call(_order$createdAt)))]), _c('span', {
      staticClass: "txt txt--sm pl-sm-8px mt-4px mt-sm-0"
    }, [_vm._v("주문번호: " + _vm._s(order === null || order === void 0 ? void 0 : order.orderNo))])])]), _c('template', {
      slot: "default"
    }, [_c('order-item-complete', _vm._g(_vm._b({
      staticClass: "v-size--xx-small mr-2",
      attrs: {
        "outlined": "",
        "color": "grey"
      }
    }, 'order-item-complete', {
      order
    }, false), {
      init: _vm.init
    })), _c('order-view', {
      ref: (_vm$orders$index = _vm.orders[index]) === null || _vm$orders$index === void 0 ? void 0 : _vm$orders$index._id,
      refInFor: true,
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var attrs = _ref.attrs,
            on = _ref.on;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "v-size--xx-small",
            attrs: {
              "outlined": "",
              "color": "grey"
            }
          }, 'v-btn', attrs, false), on), [_vm._v("상세보기")])];
        }
      }], null, true),
      model: {
        value: _vm.orders[index],
        callback: function ($$v) {
          _vm.$set(_vm.orders, index, $$v);
        },
        expression: "orders[index]"
      }
    })], 1)], 2), _c('div', {
      staticClass: "border-t border-2 border-dark"
    }, [_vm._l(order.purchases, function (purchase) {
      return [_c('purchase-item', {
        key: purchase._id,
        attrs: {
          "value": purchase,
          "isOrderListItem": ""
        },
        on: {
          "click": function ($event) {
            _vm.$refs[purchase._order][0].$data.shows = true;
          }
        },
        scopedSlots: _vm._u([{
          key: "actions",
          fn: function () {
            return [_c('v-row', {
              staticClass: "row--xs"
            }, [_c('purchase-item-claim', _vm._g({
              attrs: {
                "value": purchase
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref2) {
                  var attrs = _ref2.attrs,
                    on = _ref2.on;
                  return [_c('v-col', {
                    staticClass: "mw-100 flex-grow-1 flex-shrink-0",
                    attrs: {
                      "cols": "4",
                      "md": "12"
                    }
                  }, [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "grey"
                    },
                    on: {
                      "click": function ($event) {
                        $event.preventDefault();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v("취소 신청")])], 1)];
                }
              }], null, true)
            }, {
              init: _vm.init
            })), _c('purchase-item-claim-withdraw', _vm._g({
              attrs: {
                "value": purchase
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref3) {
                  var attrs = _ref3.attrs,
                    on = _ref3.on;
                  return [_c('v-col', {
                    staticClass: "mw-100 flex-grow-1 flex-shrink-0",
                    attrs: {
                      "cols": "4",
                      "md": "12"
                    }
                  }, [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "grey"
                    },
                    on: {
                      "click": function ($event) {
                        $event.preventDefault();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v("취소 철회")])], 1)];
                }
              }], null, true)
            }, {
              init: _vm.init
            })), purchase.type != _vm.PURCHASE_TYPES.STOCK.value ? _c('purchase-item-delivery', {
              attrs: {
                "value": purchase
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref4) {
                  var attrs = _ref4.attrs,
                    on = _ref4.on;
                  return [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "primary"
                    },
                    on: {
                      "click": function ($event) {
                        $event.stopPropagation();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v("배송 조회")])];
                }
              }], null, true)
            }) : _vm._e(), purchase.type != _vm.PURCHASE_TYPES.STOCK.value ? _c('purchase-item-claim', _vm._g({
              attrs: {
                "value": purchase,
                "type": _vm.PURCHASE_CLAIM_STATUSES.EXCHANGE_REQUESTED.value
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref5) {
                  var attrs = _ref5.attrs,
                    on = _ref5.on;
                  return [_c('v-col', {
                    staticClass: "mw-100 flex-grow-1 flex-shrink-0",
                    attrs: {
                      "cols": "4",
                      "md": "12"
                    }
                  }, [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "grey"
                    },
                    on: {
                      "click": function ($event) {
                        $event.preventDefault();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v("교환·반품 신청")])], 1)];
                }
              }], null, true)
            }, {
              init: _vm.init
            })) : _vm._e(), purchase.type != _vm.PURCHASE_TYPES.STOCK.value ? _c('purchase-item-claim-withdraw', _vm._g({
              attrs: {
                "value": purchase,
                "type": _vm.PURCHASE_CLAIM_STATUSES.EXCHANGE_REQUESTED.value
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref6) {
                  var attrs = _ref6.attrs,
                    on = _ref6.on;
                  return [_c('v-col', {
                    staticClass: "mw-100 flex-grow-1 flex-shrink-0",
                    attrs: {
                      "cols": "4",
                      "md": "12"
                    }
                  }, [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "grey"
                    },
                    on: {
                      "click": function ($event) {
                        $event.preventDefault();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v("교환·반품 철회")])], 1)];
                }
              }], null, true)
            }, {
              init: _vm.init
            })) : _vm._e(), purchase.type != _vm.PURCHASE_TYPES.STOCK.value ? _c('purchase-item-claim-withdraw', _vm._g({
              attrs: {
                "value": purchase,
                "type": _vm.PURCHASE_CLAIM_STATUSES.RETURN_REQUESTED.value
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref7) {
                  var attrs = _ref7.attrs,
                    on = _ref7.on;
                  return [_c('v-col', {
                    staticClass: "mw-100 flex-grow-1 flex-shrink-0",
                    attrs: {
                      "cols": "4",
                      "md": "12"
                    }
                  }, [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "grey"
                    },
                    on: {
                      "click": function ($event) {
                        $event.preventDefault();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v("교환·반품 철회")])], 1)];
                }
              }], null, true)
            }, {
              init: _vm.init
            })) : _vm._e(), _c('purchase-item-claim-reject', {
              attrs: {
                "value": purchase
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref8) {
                  var attrs = _ref8.attrs,
                    on = _ref8.on,
                    title = _ref8.title;
                  return [_c('v-col', {
                    staticClass: "mw-100 flex-grow-1 flex-shrink-0",
                    attrs: {
                      "cols": "4",
                      "md": "12"
                    }
                  }, [_c('v-btn', _vm._g(_vm._b({
                    attrs: {
                      "block": "",
                      "outlined": "",
                      "color": "grey"
                    },
                    on: {
                      "click": function ($event) {
                        $event.preventDefault();
                      }
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(title) + " 거절 사유")])], 1)];
                }
              }], null, true)
            })], 1)];
          },
          proxy: true
        }], null, true)
      })];
    })], 2)], 1)], 2);
  }), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading && !((_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length),
      expression: "!loading && !items?.length"
    }],
    staticClass: "text-center pt-80px"
  }, [_c('div', {
    staticClass: "mb-18px mb-md-24px"
  }, [_c('v-icon', {
    attrs: {
      "size": "60px",
      "color": "primary"
    }
  }, [_vm._v("mdi-view-list")])], 1), _c('div', {
    staticClass: "tit tit--sm"
  }, [_vm._v("주문하신 상품이 없습니다.")]), _c('div', {
    staticClass: "txt txt--sm mt-8px"
  }, [_vm._v("원하시는 상품을 주문해주세요.")]), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large w-100 min-w-sm-200px",
    attrs: {
      "color": "primary",
      "to": "/shop"
    }
  }, [_vm._v("쇼핑 계속하기")])], 1)], 1)], 1)])]), _vm.hasMoreItems ? _c('div', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect.quiet",
      value: _vm.loadInfinite,
      expression: "loadInfinite",
      modifiers: {
        "quiet": true
      }
    }],
    staticClass: "btn-wrap"
  }, [_c('v-btn', _vm._b({
    attrs: {
      "outlined": "",
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.loadMore
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 더 보기 ")])], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }